export default "__VITE_ASSET__98c36fe3__"